import React from 'react';
import { Box } from '@mui/material';
import Sidebar from 'layouts/components/survey-sidebar';
import AnswerTargetedSurvey from './answer-the-survey/answer-targeted-survey';
import StartTargetedSurvey from './start-survey/start-targeted-survey';

const TargetedSurvey = () => {
    const [surveyStep, setSurveyStep] = React.useState<number>(0);

    const config: Record<number, React.ReactElement> = {
        0: <StartTargetedSurvey setSurveyStep={setSurveyStep} />,
        1: <AnswerTargetedSurvey setSurveyStep={setSurveyStep} />,
    };

    return (
        <Box>
            <Sidebar
                surveyStep={surveyStep}
                setSurveyStep={() => setSurveyStep(0)}
            />
            {config[surveyStep]}
        </Box>
    );
};

export default TargetedSurvey;
